import { styled } from '@mui/system'
import { colors, zIndex } from '../../consts'
import { KeyboardArrowDownIcon } from '../../LazyComponents/lazyIcons'

type SlideUpProps = {
  visible: boolean
  height: string
  width: string
  bgColor: string
  slideDuration?: number
  noBackground?: boolean
  slideupHeight?: string
}

export const SlideUpContainer = styled('div')<SlideUpProps>(
  ({ visible, slideDuration, theme }) => ({
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: visible ? 0 : '-100%',
    height: '33%',
    background: '#fff',
    boxShadow: '0px -2px 10px rgba(0, 0, 0, 0.15)',
    transition: `bottom ${slideDuration || 0.8}s`,
    zIndex: zIndex.slideupOverlay,
  })
)

export const ToggleSlideUpContainer = styled('div')<SlideUpProps>(
  ({ visible, slideupHeight, slideDuration, theme }) => ({
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    height: slideupHeight || '33%',
    background: '#fff',
    boxShadow: '0px -2px 10px rgba(0, 0, 0, 0.15)',
    transition: `transform ${slideDuration || 0.8}s ease`,
    transform: visible ? 'translateY(0)' : `translateY(calc(100% - 50px))`,
    zIndex: zIndex.slideupOverlay,
    [theme.breakpoints.down('md')]: {
      transform: visible ? 'translateY(0)' : `translateY(calc(100% - 40px))`,
    },
  })
)

export const CloseButton = styled('button')({
  position: 'absolute',
  top: 8,
  right: 8,
  background: 'none',
  border: 'none',
  fontSize: '1.5rem',
  fontWeight: 'bold',
  cursor: 'pointer',
})

export const GenSlideUpContainer = styled('div')<SlideUpProps>(
  ({ height, visible, noBackground, bgColor, width, theme }) => ({
    position: 'fixed',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: width ?? '100%',
    borderRadius: '20px 20px 0 0',
    bottom: visible ? 0 : '-100%',
    height: height,
    background: noBackground ? 'none' : bgColor,
    zIndex: zIndex.slideupOverlay,
    transition: `bottom .4s ease-in`,
    [theme.breakpoints.down('md')]: {
      // width always set to 100% on mobile
      width: '100%',
    },
    '& .closeX': {
      position: 'absolute',
      top: 30,
      right: 30,
      color: colors.white,
      background: colors.text,
      borderRadius: '50%',
      border: `solid 1px ${colors.white}`,
      padding: '6px 10px',
      fontSize: 18,
      fontWeight: 800,
      cursor: 'pointer',
      zIndex: 99,
      [theme.breakpoints.between('md', 'lg')]: {
        right: 200,
      },
      [theme.breakpoints.down('md')]: {
        fontSize: 16,
        right: 10,
        padding: '5px 8px',
      },
    },
  })
)

export const SlideUpContentContainer = styled('div')<{ visible: boolean }>(
  ({ theme, visible }) => ({
    display: visible ? 'flex' : 'none',
    justifyContent: 'center',
    height: `calc(100% - 50px)`,
    backgroundColor: colors.offWhite,
    [theme.breakpoints.down('md')]: {
      height: `calc(100% - 40px)`,
    },
    '& .innerCon': {
      width: '60%',
      [theme.breakpoints.between('md', 'lg')]: {
        width: '80%',
      },
      [theme.breakpoints.down('md')]: {
        width: '100%',
      },
    },
  })
)

export const SlideUpTitleBar = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  height: 50,
  padding: theme.spacing(0, 10),
  background: colors.yellow,
  [theme.breakpoints.down('md')]: {
    height: 40,
    padding: theme.spacing(0, 4, 0, 10),
  },
  '& .toggleButtonCon': {
    width: '25%',
    height: 30,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    cursor: 'pointer'
  },
}))

export const RotateArrowIcon = styled(KeyboardArrowDownIcon)<{ isOpen: boolean }>(
  ({ isOpen }) => ({
    transition: 'transform 0.3s ease',
    transform: isOpen ? 'rotate(0deg)' : 'rotate(180deg)',
  })
)
